import { onUnmounted, ref } from "@vue/composition-api";

export default function useBlobUrl() {
  const blobUrls = ref<string[]>([]);

  const getBlobUrl = (file: File) => {
    const url = URL.createObjectURL(file);
    blobUrls.value.push(url);
    return url;
  };

  const revokeBlobs = () => {
    blobUrls.value.forEach(i => URL.revokeObjectURL(i));
    blobUrls.value = [];
  };

  onUnmounted(revokeBlobs);

  return {
    getBlobUrl,
    revokeBlobs,
  };
}
